import { Comunication } from 'models/Comunications'

class ComunicationDto {
    static fromJson({ id, title, body, files, createdAt, readAt, read }) {
        return new Comunication(id, title, body, files, createdAt, readAt, read)
    }
}

export default ComunicationDto
